import Auth from './Auth'
import { getDefaultRoute } from '../common/routerUtils'
const auth = new Auth()

export default (router) => {
  return async (to, from) => {
    try {
      const requireAuth = to.matched.some(record => record.meta.requireAuth)
      const isNewEnter = from.name == null
      const isActive = to.meta.active !== false
      if (requireAuth) {
        if (isNewEnter) {
          const nextTo = auth.loadNextTo()
          if (nextTo) {
            window.history.pushState({ }, '', nextTo.to.path)
            return nextTo.to.path
          }
        }
        if (to.name === 'root-child' || (isNewEnter && !isActive)) {
          const defaultRoute = getDefaultRoute(router)
          return { name: defaultRoute.name }
        }
        if (!isActive) {
          return false
        }
      }
    } catch (err) {
      console.error(err)
      return false
    }
  }
}
